module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "btn btn-sm",
    class: 'btn-' + _vm.status.class,
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.status.titulo) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu no-padder",
    on: {
      "click": _vm.hide
    }
  }, _vm._l((_vm.getStatus), function(s, k) {
    return (parseInt(k) !== parseInt(_vm.value)) ? _c('li', [_c('a', {
      attrs: {
        "tabindex": "2"
      },
      on: {
        "click": function($event) {
          return _vm.selectStatus(k)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.selectStatus(k)
        }
      }
    }, [_c('span', {
      staticClass: "label label-sm m-r-xs",
      class: 'bg-' + s.class
    }, [_vm._v(" ")]), _vm._v(" " + _vm._s(s.titulo))])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f354ea2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/BtnStatus.vue
// module id = 1688
// module chunks = 18